import { type FC, useCallback, useMemo } from 'react'

import { type VaultMediaType } from '@api'

import { Tooltip } from '@/components/ui/tooltip'
import { DIALOG_TYPE } from '@/dialogs/constants'
import { openDialog } from '@/models/dialogs'
import { type Media } from '@/modules/chatting/types'

import { MEDIA_TYPE_ICONS } from '../../../sidebar/consts'

interface Props {
  media: Media[]
}

export const OverviewMedia: FC<Props> = ({ media }) => {
  const handleOpenMedia = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.MEDIA_PREVIEW,
      allMedias: media,
    })
  }, [media])
  const mediaTypes = useMemo(
    () =>
      media.reduce(
        (acc, curr) => {
          const type = curr.type

          return { ...acc, [type]: (acc[type] || 0) + 1 }
        },
        {} as Record<VaultMediaType, number>,
      ),
    [media],
  )

  return (
    <Tooltip
      content="View media"
      side="bottom"
    >
      <div
        className="hover:text-primary-500 divide-border -mx-1.5 flex cursor-pointer divide-x-[1px]"
        onClick={handleOpenMedia}
        tabIndex={0}
        role="button"
      >
        {Object.entries(mediaTypes).map(([type, count]) => (
          <div
            className="flex items-center gap-1.5 px-1.5 [&>svg]:h-5 [&>svg]:w-5"
            key={type}
          >
            {MEDIA_TYPE_ICONS[type as keyof typeof MEDIA_TYPE_ICONS].icon}
            <span>{count}</span>
          </div>
        ))}
      </div>
    </Tooltip>
  )
}
